@if (selectedDiagnosticsCommand) {
<app-diagnostics-modal [status]="selectedDiagnosticsCommand.status"
    [errorMessage]="selectedDiagnosticsCommand.errorMessage" [steps]="selectedDiagnosticsSteps"
    (closeSignal)="selectedDiagnosticsCommand = undefined"></app-diagnostics-modal>
}

<div class="subpage-container">
    <div class="container g-0 m-0">
        <div class="d-flex align-items-center ps-5 pb-3 pt-1">
            <app-sort class="pe-2" (close)="onSortOption($event)"></app-sort>
            <app-status [statuses]="commandStatuses" class="pe-2" (close)="onStatusOption($event)"></app-status>
            <app-status [statuses]="commandTypes" [title]="'COMMAND_TYPE'" [useTranslate]="false" class="pe-2"
                (close)="onTypeOption($event)"></app-status>
            <div class="datepicker-container-wrapper position-relative">
                <div class="button-wrapper">
                    <div class="button">
                        <img alt="Date" src="assets/core/table-button/date.svg" />
                        <div class="button-text" (click)="toggleDatepicker()" [ngClass]="{ changed: startDate && endDate }">
                            <ng-container *ngIf="startDate && endDate; else noDateSelected">
                                {{ selectedDate }}
                            </ng-container>
                            <ng-template #noDateSelected>
                                <span class="nonselected-date">{{ "SELECTDATE" | translate }}</span>
                            </ng-template>
                        </div>
                        <img *ngIf="startDate && endDate" alt="Exit" src="assets/device/x.svg" (click)="clearDates()" />
                    </div>
                </div>
                @if (isDatepickerOpen) {
                <div class="overlay" (click)="toggleDatepicker()"></div>
                <app-datepicker [scale]="1.1" [range]="true" (dateRangeChanged)="onDateRangeChanged($event)"
                    [inputFromDate]="startDate" [inputToDate]="endDate"></app-datepicker>
                }
            </div>
        </div>
        <div class="row g-0 m-0">
            <table>
                <thead>
                    <tr>
                        <th></th>
                        <th><span>{{ "DATE" | translate }}</span></th>
                        <th><span>{{ "COMMAND" | translate }}</span></th>
                        <th><span>{{ "COMMAND_SOURCE" | translate }}</span></th>
                        <th><span>{{ "INITIATED_BY" | translate }}</span></th>
                        <th><span>{{ "ACTION" | translate }}</span></th>
                        <th><span>{{ "STATUS" | translate }}</span></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of commands; let i = index" [class.clickable]="isDiagnosticsCommand(row)"
                        (click)="openCommandDetails(row)">
                        <td appIsNew [executedTime]="row.startTime!"></td>
                        <td><span>{{ row.startTime ? (row.startTime | date: 'dd MMM yyyy, h:mm a') : '/' }}</span></td>
                        <td><span>{{ row.type }}</span></td>
                        <td><span>{{ row.source }}</span></td>
                        <td><span>{{ row.userEmail || '-' }}</span></td>
                        <!-- The command effect in words: the action the command reported where it
                             has one of its own, otherwise the command type spelled out. -->
                        <td><span>{{ (row.action ? 'COMMAND_ACTION_' + row.action : 'COMMAND_TYPE_' + row.type)
                                | uppercase | translate }}</span></td>
                        <td (click)="printResponseOfCommand($event, row)">
                            <div class="status-container">
                                <span [ngClass]="{
                                    'status-pending': row.status === 'Pending' || row.status === 'Scheduled',
                                    'status-completed': row.status === 'Success',
                                    'status-in-progress': row.status === 'InProgress',
                                    'status-finalize': row.status === 'Finalize',
                                    'status-failed': row.status === 'Failed',
                                    'status-canceled': row.status === 'Canceled',
                                    'status-fatal-error': row.status === 'ErrorOccured'
                                }">{{ row.status === 'ErrorOccured' ? ('FATAL_ERROR' | translate) : row.status }}</span>
                                <svg-icon *ngIf="row.status === 'Failed'" class="retry-icon ps-2"
                                    src="assets/device/refresh.svg" (click)="retry($event, row)"></svg-icon>
                            </div>
                        </td>
                        <td class="more-cell" [class.more-cell-active]="activeRow === i">
                            <svg-icon *ngIf="canCancel(row)" alt="More" class="more-icon ps-1"
                                src="assets/device/column-menu.svg"
                                (click)="setActiveRow(i); $event.stopPropagation()"></svg-icon>
                            <div *ngIf="activeRow === i" class="positioning">
                                <div class="overlay-light" (click)="setActiveRow(null)"></div>
                                <div class="dropdown-button p-2">
                                    <div class="dropdown-button-menu p-0 m-0">
                                        <div class="dropdown-button-item d-flex justify-content-start align-items-center p-2"
                                            (click)="openCancelModal($event, row)">
                                            <svg-icon alt="Cancel" src="assets/settings/deactivate.svg"></svg-icon>
                                            <span class="ps-1 item-title">{{ "CANCEL" | translate }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="container-down">
        <app-pagination [lastPageSize]="lastPageSize" [numberOfDevices]="numberOfCommands" [pageSize]="pageSize"
            [currentPage]="currentPage" (pageChange)="pageChange($event)"></app-pagination>
    </div>
</div>

<app-confirm-dialog *ngIf="isCancelModalOpen" titleKey="CANCEL" question="CANCEL_COMMAND_CONFIRM"
    (confirm)="confirmCancel()" (cancel)="closeCancelModal()"></app-confirm-dialog>
